import { createContext, useContext } from "react";

const ModalContext = createContext(false);

export const useIsInsideModal = () => useContext(ModalContext);
export default ModalContext;
